import { graphql } from "../../../generated/gql";

export const SaveAsTemplateGQL = graphql(`
  mutation CreateTemplate($input: CreateTemplateInput!) {
    createTemplate(input: $input) {
      id
      name
    }
  }
`);
